import { render, staticRenderFns } from "./TrackDeliveryDialog.vue?vue&type=template&id=1406c853&"
import script from "./TrackDeliveryDialog.vue?vue&type=script&lang=js&"
export * from "./TrackDeliveryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports